<!--错题练习-->
<template>
    <div class="el-WrongExercise">
        <!-- <h1 class="head_title" style="margin-top:-20px;">
            Python课程设计 错题练习
        </h1> -->
        <el-row class="page_content">
            <h1 class="head_title_white">
                <h1 style="float: left;color: #000000;line-height: 40px;margin: 0;">{{courseName}} 错题练习</h1>
                <el-button type="primary" @click="backOff">返 回</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px;">
                <div style="font-size: 20px;margin: 0 -10px;text-align: right;padding-bottom: 20px;border-bottom: 1px dashed rgb(171, 171, 171);">
                    <span style="float: left;line-height: 40px;">{{courseName}}</span>
                    <el-button type="primary" @click="xsda">{{allState == 1?'显示':'隐藏'}}答案所有</el-button>
                    <el-button type="primary" @click="submitInfo">提交</el-button>
                </div>
                <el-row class="all_subject">
                    <template v-for='(item,index) in homeworkInfo'>
                      <template v-if="index == 0 || (homeworkInfo[index  - 1].homeworkQuestionTypeName != homeworkInfo[index].homeworkQuestionTypeName)">
                        <h1>{{item.homeworkQuestionTypeName}}</h1>
                      </template>
                      <template v-if="item.homeworkQuestionTypeConcat == 1">
                        <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                            <el-row class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <ul>
                                      <el-radio-group v-model="radio[item.homeworkQuestionId]" @change="radioChange(item.homeworkQuestionId,index)">
                                          <li v-for="(it,inde) in item.homeworkQuestionOptionList">
                                            <el-radio :disabled="submitTag" :label="it.homeworkQuestionOptionOptionSign">
                                              <el-row style="float: left;" v-html="it.homeworkQuestionOptionOptionSign +'、'"></el-row>
                                              <el-row style="float: left;" v-html="$imgHtml(it.homeworkQuestionOptionOptionContent)"></el-row>
                                            </el-radio>
                                          </li>
                                      </el-radio-group>
                                    </ul>
                                </el-col>
                                <el-col :span="8">
                                  <template v-if="item.homeworkQuestionAnswer == item.studentAnswerNew">
                                    <i v-if="submitTag" class="el-icon-success yesIcon"></i>
                                  </template>
                                  <template v-else>
                                    <i v-if="submitTag" class="el-icon-error noIcon"></i>
                                  </template>
                                  <el-button type="primary" style="float: right;position: absolute;bottom: 20px;right: 70px;" size="small" @click="show_daan(index,'r')">答案</el-button>
                                  <el-button type="danger" style="float: right;position: absolute;bottom: 20px;right: 0;" size="small" @click="del_wrong(item)">移除</el-button>
                                </el-col>
                            </el-row>
                            <div class="topic_analysis_">
                                <el-row>本题答案：{{item.homeworkQuestionAnswer}}</el-row>
                                <el-row><p style="float: left;">题目解析：</p><label style="float: left;" v-html="item.homeworkQuestionAnalysis"></label></el-row>
                            </div>
                        </el-row>
                      </template>

                      <template v-if="item.homeworkQuestionTypeConcat == 2">
                        <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                            <el-row class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                            </el-row>
                            <el-row>
                              <el-col :span="16">
                                  <ul>
                                    <el-checkbox-group v-model="checkbox[item.homeworkQuestionId]" @change="checkboxChange(item.homeworkQuestionId,index)">
                                        <li v-for="(it,inde) in item.homeworkQuestionOptionList">
                                          <el-checkbox :disabled="submitTag" :label="it.homeworkQuestionOptionOptionSign">
                                            <el-row style="float: left;" v-html="it.homeworkQuestionOptionOptionSign +'、'"></el-row>
                                            <el-row style="float: left;" v-html="$imgHtml(it.homeworkQuestionOptionOptionContent)"></el-row>
                                          </el-checkbox>
                                        </li>
                                    </el-checkbox-group>
                                  </ul>
                              </el-col>
                              <el-col :span="8">
                                <template v-if="item.homeworkQuestionAnswer == item.studentAnswerNew">
                                  <i v-if="submitTag" class="el-icon-success yesIcon"></i>
                                </template>
                                <template v-else>
                                  <i v-if="submitTag" class="el-icon-error noIcon"></i>
                                </template>
                                <el-button type="primary" style="float: right;position: absolute;bottom: 20px;right: 70px;" size="small" @click="show_daan(index,'c')">答案</el-button>
                                <el-button type="danger" style="float: right;position: absolute;bottom: 20px;right: 0;" size="small" @click="del_wrong(item)">移除</el-button>
                              </el-col>
                            </el-row>
                            <el-row class="topic_analysis_">
                              <el-row>本题答案：{{item.homeworkQuestionAnswer}}</el-row>
                              <el-row><p style="float: left;">题目解析：</p><label style="float: left;" v-html="item.homeworkQuestionAnalysis"></label></el-row>
                            </el-row>
                        </el-row>
                      </template>

                      <template v-if="item.homeworkQuestionTypeConcat == 3">
                        <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                            <el-row class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <ul>
                                      <el-radio-group :disabled="submitTag" v-model="judgeQuestion[item.homeworkQuestionId]" @change="judgeQuestionChange(item.homeworkQuestionId,index)">
                                          <li><el-radio label="对">对</el-radio></li>
                                          <li><el-radio label="错">错</el-radio></li>
                                      </el-radio-group>
                                    </ul>
                                </el-col>
                                <el-col :span="8">
                                  <template v-if="item.homeworkQuestionAnswer == item.studentAnswerNew">
                                    <i v-if="submitTag" class="el-icon-success yesIcon"></i>
                                  </template>
                                  <template v-else>
                                    <i v-if="submitTag" class="el-icon-error noIcon"></i>
                                  </template>
                                  <el-button type="primary" style="float: right;position: absolute;bottom: 20px;right: 70px;" size="small" @click="show_daan(index,'j')">答案</el-button>
                                  <el-button type="danger" style="float: right;position: absolute;bottom: 20px;right: 0;" size="small" @click="del_wrong(item)">移除</el-button>
                                </el-col>
                            </el-row>
                            <div class="topic_analysis_">
                              <el-row>本题答案：{{item.homeworkQuestionAnswer}}</el-row>
                              <el-row><p style="float: left;">题目解析：</p><label style="float: left;" v-html="item.homeworkQuestionAnalysis"></label></el-row>
                            </div>
                        </el-row>
                      </template>

                      <template v-if="item.homeworkQuestionTypeConcat == 4">
                        <el-row :key="index" :class="'jump'+item.homeworkQuestionId">
                            <el-row class="stem">
                              <el-row style="float:left;margin-top:3px;margin-right: 10px;">{{index + 1}}.</el-row>
                              <el-row style="float:left;" v-html="$imgHtml(item.homeworkQuestionStem)"></el-row>
                            </el-row>
                            <el-row>
                                <el-col :span="16">
                                    <el-input :disabled="submitTag" @blur="shortAnswerBlur(item.homeworkQuestionId,index)" :rows="3" type="textarea" style="margin:10px 0;" v-model="shortAnswer[item.homeworkQuestionId]"></el-input>
                                </el-col>
                                <el-col :span="8">
                                  <template v-if="item.homeworkQuestionAnswer == item.studentAnswerNew">
                                    <i v-if="submitTag" class="el-icon-success yesIcon"></i>
                                  </template>
                                  <template v-else>
                                    <i v-if="submitTag" class="el-icon-error noIcon"></i>
                                  </template>
                                  <el-button type="primary" style="float: right;position: absolute;bottom: 20px;right: 70px;" size="small" @click="show_daan(index,'s')">答案</el-button>
                                  <el-button type="danger" style="float: right;position: absolute;bottom: 20px;right: 0;" size="small" @click="del_wrong(item)">移除</el-button>
                                </el-col>
                            </el-row>
                            <div class="topic_analysis_">
                                <el-row>本题答案：{{item.homeworkQuestionAnswer}}</el-row>
                                <el-row><p style="float: left;">题目解析：</p><label style="float: left;" v-html="item.homeworkQuestionAnalysis"></label></el-row>
                            </div>
                        </el-row>
                      </template>
                    </template>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: "WrongExercise",
  data() {
    return {
      courseName:"",
      submitTag:false, //是否点击提交
      homeworkStudentId:this.$route.query.homeworkStudentId,
      homeworkInfo:[],
      radio:{}, //单选题答案
      checkbox:{},//多选题答案
      judgeQuestion:{},//判断题
      shortAnswer:{},//简答题
      daan_show:{}, //题目解析
      allState:1 //1:全部隐藏 2：全部显示
    };
  },
  created() {
   this.wrongQuestionInfo();
  },
  methods: {
      backOff(){
        this.$router.go(-1);
      },
      radioChange(homeworkQuestionId,index){ //单选题选择
        this.homeworkInfo[index].studentAnswerNew = this.radio[homeworkQuestionId];
        this.radio = Object.assign({},this.radio);
      },
      checkboxChange(homeworkQuestionId,index){ //多选题选择
        let aa = this.checkbox[homeworkQuestionId].sort((a, b) => { //按照abcd排序
         return a.localeCompare(b);
        });
        this.homeworkInfo[index].studentAnswerNew = aa.join(',');
        this.checkbox = Object.assign({},this.checkbox);
      },
      judgeQuestionChange(){ //判断题
        this.homeworkInfo[index].studentAnswerNew = this.judgeQuestion[homeworkQuestionId];
        this.judgeQuestion = Object.assign({},this.judgeQuestion);
      },
      shortAnswerBlur(homeworkQuestionId,index){ //简答题
        this.homeworkInfo[index].studentAnswerNew = this.shortAnswer[homeworkQuestionId];
        this.shortAnswer = Object.assign({},this.shortAnswer);
      },
      xsda(){  //显示答案
          if(this.allState == 2){
            this.allState = 1;
            //$(".topic_analysis_s,.topic_analysis_j,.topic_analysis_c,.topic_analysis_r").slideUp(1000);
            $(".topic_analysis_").slideUp(1000);
          }else{
            this.allState = 2;
            //$(".topic_analysis_s,.topic_analysis_j,.topic_analysis_c,.topic_analysis_r").slideDown(1000);
            $(".topic_analysis_").slideDown(1000);
          }
      },
      show_daan(index,tag){ //显示单个答案
       $(".topic_analysis_:eq("+(index)+")").slideToggle(1000);
      },
      del_wrong(item){ //移除题目
        this.$store.dispatch("user/deleteWrongQuestion", {studentWrongQuestionLogId:item.studentWrongQuestionLogId}).then((ret) => {
          if (ret.code != 0 && ret.code != '0') {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          } else {
            this.courseName = ret.courseName;
            this.tableData = ret.data;
            this.total = ret.count;
          }
        });
      },
      submitInfo(){ //提交
        this.$confirm('是否确定提交？?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.submitTag = true;
          $(".topic_analysis_").slideDown(1000);
        }).catch(() => {

        });
      },wrongQuestionInfo() {
        this.$store.dispatch("user/wrongQuestionInfo", {homeworkStudentId:this.homeworkStudentId}).then((ret) => {
          if (ret.code != 0 && ret.code != '0') {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          } else {
            this.courseName = ret.courseName;
            this.homeworkInfo = ret.data;
            this.homeworkInfo.forEach((element,i) => {
              if(element.homeworkQuestionTypeConcat == 2){
                this.checkbox[element.homeworkQuestionId] = [];
              }
             });
            this.checkbox = Object.assign({},this.checkbox);
          }
        });
      }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-WrongExercise{
    .head_title_white{
        text-align: right;
        margin-bottom:0;
        padding: 10px 30px;
    }
    .yesIcon{
      font-size: 100px;
      color: #409eff;
      float: right;
      margin-right: 50px;
    }
    .noIcon{
      font-size: 100px;
      color: red;
      float: right;
      margin-right: 50px;
    }
    .bg_{
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }
    .learning_img{
        width: 280px;height: 220px;border: 1px solid rgb(238, 238, 238);float: left;margin-right: 20px;
    }
    .el-main{
        min-width: 1200px;
    }
    .odyContainer{
        height: 100%;
    }
    .stem{
        font-size: 18px;
    }
    p{
        margin: 0;
    }

    .all_subject{
        height: calc(100vh - 300px);overflow: auto;
        ul li{
            list-style-type:none;
            line-height:30px;
            .el-radio__label{
                font-size: 18px;
            }

        }
    }
    .topic_analysis_,.topic_analysis_s,.topic_analysis_j,.topic_analysis_c,.topic_analysis_r{
        padding:10px 10px 10px 40px;border:1px solid #409eff;margin-bottom:10px;border-radius:5px;display: none;
    }
    .all_subject::-webkit-scrollbar {
        display: none;
    }
    .el-radio__input,.el-radio__label,.el-checkbox__input,.el-checkbox__label{
      float: left;
    }
    .el-radio__inner,.el-checkbox__inner{
      margin-top: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/WrongExercise.vue